import type { FC } from 'react'
import { InputHelpText } from '@/components/ui/input-help-text'
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue
} from '@/components/ui/select'
import { type TKey, useTranslation } from '@/translations/i18n'

interface TableStakeQuestionProps {
	title: string
	description: string
	answerOptions: string[]
	code: string
	value: string
	onChange: (value: string) => void
	disabled?: boolean
	errorMessage?: string
	ref: React.ForwardedRef<HTMLInputElement>
}

export const TableStakeQuestion: FC<TableStakeQuestionProps> = ({
	title,
	description,
	answerOptions,
	code,
	value,
	onChange,
	disabled = false,
	errorMessage,
	ref
}) => {
	const { t } = useTranslation()
	const selectedLabel = value
		? t(`luxe_submissions:score_form.${code}_options.${value}` as TKey)
		: null
	return (
		<div className='flex flex-col gap-2'>
			<div className='flex flex-col gap-1'>
				<p className='font-semibold text-base text-neutral-900'>
					{title}
				</p>
				<p className='text-neutral-900 text-sm'>{description}</p>
			</div>
			<Select
				disabled={disabled}
				inputRef={ref}
				onValueChange={(val) => {
					if (val) {
						onChange(val)
					}
				}}
				value={value ?? ''}
			>
				<SelectTrigger className='w-full'>
					<SelectValue>
						{selectedLabel ??
							t('luxe_submissions:score_form.select_option')}
					</SelectValue>
				</SelectTrigger>
				<SelectContent className='w-(--anchor-width)'>
					{answerOptions.map((option) => (
						<SelectItem key={option} value={option}>
							{t(
								`luxe_submissions:score_form.${code}_options.${option}` as TKey
							)}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
			{errorMessage && <InputHelpText error={errorMessage} />}
		</div>
	)
}
